module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-noya-01-white.8fed83b1.jpg";